import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * Service to handle table actions events since we cannot directly attach output into the app-table component
 * because it is wrapped inside the ntv-table component
 */
@Injectable({
    providedIn: 'root',
})
export class TableActionService {
    /**
     * Subject to emit action click events
     */
    private actionClick$ = new Subject<{ action: string; row: any }>();

    /**
     * Observable to subscribe to action click events
     */
    public actionClick = this.actionClick$.asObservable();

    /**
     * Emits an action click event
     * @param action - The action name/icon
     * @param row - The row data
     */
    public emit(action: string, row: any): void {
        this.actionClick$.next({ action, row });
    }
}
